import { HashLink } from 'react-router-hash-link';

function classNames(...classes) {
    return classes.filter(Boolean).join(" ")
}

export function NavLinks({siteConfig, isDark}) {

  return (siteConfig?.menus ?? []).map((data, index) => (

      <>

        {
            data.url  && (
                <HashLink
                    key={data.id}
                    to={data.url}
                    className={classNames(
                        "relative -mx-3 -my-2  px-3 py-2  text-sm tracking-wide uppercase",
                        isDark ?  "text-white/80 transition-colors  delay-150 hover:text-white hover:delay-[0ms]" :
                            "text-indigo-950/80 transition-colors delay-150 hover:text-indigo-950 hover:delay-[0ms]",
                    )}
                >
                    {data.name}
                </HashLink>
            )
        }

      
          

      </>



  ))
}
